import { request } from "@src/utils/apiClient";
import { AppUtils } from "@src/utils";
const BASE_OPERATOR_SERVICE = "/operatorDashboard";
const BASE_NOTIFICATION_SERVICE = "/notifications";

export const getOperatorProfile = async () => {
  return request({
    method: "GET",
    endpoint: BASE_OPERATOR_SERVICE + "/profile",
  });
};

export const getGoalSummaries = async () => {
  return request({
    endpoint: BASE_OPERATOR_SERVICE + "/goals/summaries",
    method: "GET",
  });
};

export const getLatestEvents = async (limit) => {
  return request({
    endpoint: BASE_OPERATOR_SERVICE + "/events/latest",
    method: "GET",
    params: {
      n: limit,
    },
  });
};

export const getBestEvent = async () => {
  return request({
    endpoint: BASE_OPERATOR_SERVICE + "/events/best",
    method: "GET",
  });
};

export const getEvents = async (from, to) => {
  return request({
    endpoint: BASE_OPERATOR_SERVICE + "/events",
    method: "GET",
    params: {
      startDate: AppUtils.serializeDate(from),
      endDate: AppUtils.serializeDate(to),
    },
  });
};

export const getEventById = async (_, eventId) => {
  return request({
    endpoint: `${BASE_OPERATOR_SERVICE}/events/${eventId}`,
    method: "GET",
  });
};

export const getIncompleteEvents = async () => {
  return request({
    endpoint: BASE_OPERATOR_SERVICE + "/events/incomplete",
    method: "GET",
  });
};

export const getImpact = async () => {
  return request({
    endpoint: BASE_OPERATOR_SERVICE + "/impact",
    method: "GET",
  });
};

export const getCustomerCommitments = async () => {
  return request({
    endpoint: BASE_OPERATOR_SERVICE + "/commitments",
    method: "GET",
  });
};

export const getBaselines = async () => {
  return request({
    endpoint: BASE_OPERATOR_SERVICE + "/profile/baselines",
    method: "GET",
  });
};

export const submitProfileUpdate = async (data) => {
  return request({
    method: "PUT",
    endpoint: `${BASE_OPERATOR_SERVICE}/profile`,
    body: data,
  });
};

export const updateEventComment = async (inputData) => {
  return request(
    {
      method: "POST",
      endpoint: `${BASE_OPERATOR_SERVICE}/events/${inputData.eventId}/comments`,
      body: inputData,
    },
    true,
  );
};

export const saveSelfReport = async (data) => {
  return request(
    {
      method: "POST",
      endpoint: `${BASE_OPERATOR_SERVICE}/events/self-report`,
      body: data,
    },
    true,
  );
};

export const getNotifications = async (params) => {
  return request({
    endpoint: `${BASE_NOTIFICATION_SERVICE}/me/inapp_feed`,
    method: "GET",
    params: {
      operatorCode: params.operatorCode,
      role: params.role,
      limit: params.limit,
      offset: params.offset,
      "subtypes[]": params.subtypes,
    },
  });
};

export const readNotification = async (data) => {
  return request({
    endpoint: `${BASE_NOTIFICATION_SERVICE}/me/inapp_seen`,
    method: "POST",
    body: data,
  });
};

export function operatorProfileLink(data) {
  return request({
    method: "POST",
    endpoint: `${BASE_OPERATOR_SERVICE}/profile/link`,
    body: data,
  });
}
